import { Directive, ElementRef, inject, Renderer2 } from '@angular/core';

@Directive({
    selector: '[xuiTextareaHidpiRenderer]',
})
export class TextareaHidpiRendererDirective {
  private el = inject(ElementRef);
  private renderer = inject(Renderer2);

  constructor() {
    this.applyStyles();
  }

  private applyStyles() {
    const textarea = this.el.nativeElement;
    if (textarea.tagName.toLowerCase() === 'textarea') {
      this.renderer.setStyle(textarea, 'text-rendering', 'optimizeLegibility');
      this.renderer.setStyle(textarea, '-webkit-font-smoothing', 'antialiased');
      this.renderer.setStyle(textarea, '-moz-osx-font-smoothing', 'grayscale');
    }
  }
}
